// src/components/Articles/Image.js

import React from 'react';
import { Link } from 'react-router-dom';
import './Image.css';

const Image = ({ src, alt, to }) => {
  const handleClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <Link to={to} onClick={handleClick}>
      <img className="article-image" src={src} alt={alt} />
    </Link>
  );
};

export default Image;
